import React from "react";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

import { isMobile } from "react-device-detect";

type FooterProps = {
  userFullName?: string;
};

function Footer(props: FooterProps) {
  const CONTACT = (
    <Link
      href={"mailto:contact@usesalus.com?subject=[Site Inquiry] " + (props.userFullName ?? "")}
      target="_blank"
      rel="noreferrer"
      sx={{ textDecoration: "none", color: "inherit" }}
    >
      Contact Us
    </Link>
  );

  const LINK1 = (
    <Link
      href="https://app.usesalus.com/terms"
      target="_blank"
      rel="noreferrer"
      sx={{ textDecoration: "none", color: "inherit" }}
    >
      Legal Terms and Disclaimer
    </Link>
  );

  const LINK2 = (
    <Link
      href="https://app.usesalus.com/terms#privacy"
      target="_blank"
      rel="noreferrer"
      sx={{ textDecoration: "none", color: "inherit" }}
    >
      Privacy Policy
    </Link>
  );

  const COPYRIGHT = "© " + new Date().getFullYear();

  if (isMobile) {
    return (
      <AppBar sx={{ bottom: 0, top: "auto", flexGrow: 0 }}>
        <Toolbar
          variant="dense"
          sx={{
            position: "relative",
            flexGrow: 0,
            bgcolor: "primary.dark",
            color: "background.dark",
            display: "flex",
            justifyContent: "center",
            height: "auto",
            minHeight: "32px",
          }}
        >
          <Typography variant="body2" whiteSpace="nowrap" sx={{ fontSize: "0.75rem", verticalAlign: "middle" }}>
            {CONTACT} | {LINK1} | {LINK2} | {COPYRIGHT}
          </Typography>
        </Toolbar>
      </AppBar>
    );
  }

  return (
    <AppBar position="fixed" sx={{ bottom: 0, top: "auto", flexGrow: 0 }}>
      <Toolbar
        variant="dense"
        sx={{
          position: "relative",
          flexGrow: 0,
          bgcolor: "primary.dark",
          color: "background.dark",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2">
          {CONTACT} | {LINK1} | {LINK2} | {COPYRIGHT}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
export default Footer;
